import { createFileRoute } from "@tanstack/react-router";
import { GameScreen } from "@ui/screens/GameScreen";

export const Route = createFileRoute("/game")({
  component: GameScreen,
});
